import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  Box,
  Heading,
  Image,
  NeoColor,
  Spacing,
  Stack,
  StackItem,
  Text,
} from "@noom/wax-component-library";

import { NeoButton } from "@/components";
import {
  QuestionComponentProps,
  QuestionDefinition,
} from "@/components/survey/Question";
import { useGoto, useTrackEvent } from "@/hooks";

import { BaseInterstitial } from "../core";

const QUESTION_ID = "connectHealthRecordsInProgress";

const ConnectHealthRecordsInProgress: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
}) => {
  const { openApp } = useGoto();
  const { trackIdentifiedPageViewed } = useTrackEvent();
  const { t } = useTranslation();

  useEffect(() => {
    trackIdentifiedPageViewed(QUESTION_ID);
  }, []);

  const handleCtaClick = () => {
    openApp();
  };

  return (
    <BaseInterstitial
      backgroundColor={NeoColor.blue.skyLight}
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      questionId={QUESTION_ID}
    >
      <Box height="60px" />
      <Image src="/assets/img/connect-health-records-clock.svg" />

      <Stack spacing={Spacing[4]}>
        <Heading>{t("connectHealthRecordsInProgress.heading")}</Heading>
        <Text>{t("connectHealthRecordsInProgress.body")}</Text>
      </Stack>

      <StackItem display="flex" justifyContent="center">
        <NeoButton onClick={handleCtaClick}>
          {t("connectHealthRecordsInProgress.ctaText")}
        </NeoButton>
      </StackItem>
    </BaseInterstitial>
  );
};

export const Q_CONNECT_HEALTH_RECORDS_IN_PROGRESS: QuestionDefinition = {
  id: QUESTION_ID,
  shouldShowQuestion: () => true,
  component: ConnectHealthRecordsInProgress,
};
